const ENV_FLAG = 'VITE_PLATFORM_TEST_API'

export function isPlatformTestApiEnabled(): boolean {
  return String((import.meta.env as Record<string, unknown>)?.[ENV_FLAG] ?? '').toLowerCase() === 'true'
}
